import { Component, OnInit } from '@angular/core';
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import {CookieService} from "../../services/coockieService/coockie.service";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";

@Component({
  selector: 'app-lock-modal',
  templateUrl: './lock-modal.component.html',
  styleUrls: ['./lock-modal.component.scss']
})
export class LockModalComponent implements OnInit {

  public Yiit = Yiit;
  public modalMessage = window['OBJECT_DRAG_MSG'];
  private isDetailsWasOpened = false;

  ngOnInit() {
    this.modalService.modalUpdated.subscribe((event)=>{
      if (this.modalService.currentModal == '.items-lock-modal'){
        if (event == 'opened'){
          this.isDetailsWasOpened = !this.ui.isDetailsSidebarHidden;
          console.log('opened', this.isDetailsWasOpened);
          if (!this.isDetailsWasOpened){
            this.ui.hiddenDetailsSidebar = false;
          }
          document.querySelector('.global-lock-container').classList.add('es-global-icon-highlight');
          document.querySelector('.es-details-inner-wrapper .es-dragged-icon').classList.add('es-global-icon-highlight');
        }
        if (event == 'closed'){
          console.log('closed', this.isDetailsWasOpened);
          if (!this.isDetailsWasOpened){
            this.ui.hiddenDetailsSidebar = true;
          }
          document.querySelector('.global-lock-container').classList.remove('es-global-icon-highlight');
          document.querySelector('.es-details-inner-wrapper .es-dragged-icon').classList.remove('es-global-icon-highlight');
          this.cookieService.setCookie('isDraggableModalShow', true, 365);
        }
      }
    })
  }

  constructor(private modalService: EsBsModalService, private cookieService: CookieService, private ui: UiAdapterService) { }



}
